import React from 'react'
import Navbar from '../components/Navbar'
import Heroimg from '../components/Heroimg'
import Footer from '../components/Footer'
import Heroimg3 from '../components/Heroimg3'
import { Helmet } from 'react-helmet-async'
import PricingTag from '../components/PricingTag'


const Home = () => {

  return (
    <>
    <Helmet>
      <title>Home</title>
      <meta name='description' content={"'Let's explore Shitsama's world today.'"}/>
      <link rel='canonical' href='/' />
    </Helmet>
    
    <div>
      < Navbar />
      <Heroimg />
      <Heroimg3 />
      <PricingTag/>
      <Footer />
    </div>
    </>
  )
}

export default Home
